import makeService from './api';

export default makeService('control_units');
